// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"508":"5ffb3d63","661":"c122df91","784":"43ff38d7"}[chunkId] + ".js";
};